import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Award, Leaf, Hammer, Heart } from "lucide-react";

const IMG1 = "/products/corner-livaro.jpg";
const IMG2 = "/products/sofa-laura.jpg";

const VALUES = [
  { icon: Hammer, title: "Savoir-faire", desc: "Des artisans passionnés perpétuant un savoir-faire d'exception depuis trois générations." },
  { icon: Leaf, title: "Éco-responsable", desc: "Bois certifié FSC, tissus recyclés premium et mousses sans produits toxiques." },
  { icon: Award, title: "Qualité durable", desc: "Chaque canapé est conçu pour traverser les décennies avec une garantie 10 ans." },
  { icon: Heart, title: "Client au cœur", desc: "Un accompagnement personnalisé de la sélection jusqu'à l'installation chez vous." },
];

export default function About() {
  return (
    <div className="pt-6">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-3xl py-16 text-center">
          <p className="mb-3 font-accent text-xs uppercase tracking-[0.25em] text-gold-dark">Notre maison</p>
          <h1 className="font-serif text-4xl font-medium lg:text-6xl">L'art de recevoir, façonné à la main</h1>
          <p className="mt-6 text-lg text-muted-foreground">
            Depuis notre atelier, shop-canapé imagine des canapés qui allient élégance intemporelle et confort absolu. Chaque pièce raconte une histoire de matières nobles et de gestes précis.
          </p>
        </Reveal>

        <div className="grid items-center gap-10 py-12 lg:grid-cols-2">
          <Reveal><div className="overflow-hidden rounded-[2rem] shadow-luxe"><img src={IMG1} alt="Atelier" className="h-[420px] w-full object-cover" /></div></Reveal>
          <Reveal delay={0.15}>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-gold-dark">Notre histoire</p>
            <h2 className="mt-2 font-serif text-3xl lg:text-4xl">Le confort comme signature</h2>
            <p className="mt-5 text-muted-foreground">Née d'une passion pour le beau et le durable, notre maison sélectionne les meilleures matières premières européennes pour créer des canapés qui deviennent le cœur de votre foyer.</p>
            <p className="mt-4 text-muted-foreground">De la structure en hêtre massif aux finitions cousues main, rien n'est laissé au hasard. Nous croyons qu'un canapé n'est pas un simple meuble, mais l'endroit où se tissent vos plus beaux souvenirs.</p>
            <div className="mt-8 grid grid-cols-3 gap-4">
              {[["15+", "Années d'expertise"], ["10k+", "Clients satisfaits"], ["10 ans", "de garantie"]].map(([n, l]) => (
                <div key={l}><p className="font-serif text-3xl text-gold-dark">{n}</p><p className="text-xs text-muted-foreground">{l}</p></div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="grid gap-5 py-16 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.08}>
              <div className="h-full rounded-3xl border border-border bg-card p-7 shadow-soft">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-secondary text-gold-dark"><v.icon size={22} /></div>
                <h3 className="font-serif text-xl">{v.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mb-20">
          <div className="relative overflow-hidden rounded-[2rem] bg-obsidian">
            <div className="grid items-center gap-8 p-10 lg:grid-cols-2 lg:p-16">
              <div>
                <h2 className="font-serif text-3xl text-cream lg:text-4xl">Prêt à transformer votre intérieur ?</h2>
                <p className="mt-4 text-cream/60">Découvrez notre collection et trouvez le canapé qui vous ressemble.</p>
                <Link to="/canapes" className="mt-8 inline-block rounded-full bg-gold-gradient px-8 py-4 text-sm font-semibold text-obsidian transition-transform hover:scale-[1.04]">Explorer la collection</Link>
              </div>
              <div className="overflow-hidden rounded-[1.5rem]"><img src={IMG2} alt="" className="h-full min-h-[240px] w-full object-cover" /></div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
